import { EMAIL_LIST_TYPE } from '../constants/email-variables.constants';

abstract class IEmailTemplatesDAO {
    public abstract getEmailVariables(params: { accountId: number; type: EMAIL_LIST_TYPE }): Promise<IEmailVariable[]>;
    public abstract getEmailTemplatesList(params: {accountId: number}): Promise<IEmailTemplateField[]>;
    public abstract createEmailTemplate(params: IEmailTemplateFieldRequestParams): Promise<IEmailTemplateField>;
    public abstract updateEmailTemplate(params: IEmailTemplateField): Promise<IEmailTemplateField>;
    public abstract deleteEmailTemplate(params: IEmailTemplateByIdRequestParams): Promise<void>;
    public abstract getTemplateById(params: IEmailTemplateByIdRequestParams): Promise<IEmailTemplateField>;
    public abstract sendEmail(params: IEmailTemplateFieldRequestParams): Promise<void>;
};

interface IEmailVariable {
    value: string;
    description: string;
}
enum EmailTemplateTypes {
    CONNECTION_EMAIL = 'CONNECTION_EMAIL',
}

interface IEmailTemplateField {
    id: string;
    name: string;
    type: EmailTemplateTypes;
    description: string;
    to: string[];
    replyTo: string[];
    cc: string[];
    bcc: string [];
    subject: string;
    body: string;
}

interface IEmailTemplateFieldRequestParams extends IEmailTemplateField {
    accountId: number;
}

interface IEmailTemplateByIdRequestParams {
    accountId: number;
    templateId: string;
    meetingId?: number;
    eventId?: number;
}

export {
    IEmailTemplatesDAO,
    IEmailVariable,
    EmailTemplateTypes,
    IEmailTemplateField,
    IEmailTemplateFieldRequestParams,
    IEmailTemplateByIdRequestParams,
};
